import {Fragment, memo} from 'react';
import {useNumberFormatter} from './use-number-formatter';

interface FormattedCurrencyProps {
  value: number;
  currency: string;
  // opt-in: whole amounts drop their fraction ("SAR 1.00" -> "SAR 1");
  // non-whole amounts ("$2.45") keep their decimals
  hideDecimalsWhenWhole?: boolean;
}
export const FormattedCurrency = memo(
  ({value, currency, hideDecimalsWhenWhole}: FormattedCurrencyProps) => {
    if (isNaN(value)) {
      value = 0;
    }

    const stripDecimals = hideDecimalsWhenWhole && Number.isInteger(value);
    const formatter = useNumberFormatter({
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      ...(stripDecimals
        ? {minimumFractionDigits: 0, maximumFractionDigits: 0}
        : {}),
    });

    return <Fragment>{formatter.format(value)}</Fragment>;
  }
);
